import { apiEnv } from '@mgmresorts/wcl-utils';
import React from 'react';

export interface BodyScrollLockContextValue {
  enable({ allowTouchMove }: { allowTouchMove?: (el: HTMLElement) => boolean }): void;
  disable(): void;
}

export const BodyScrollLockContext = React.createContext<BodyScrollLockContextValue>({
  enable() {
    if (apiEnv === 'test') {
      return 'test';
    }

    throw new TypeError(`BodyScrollLockContext isn't initialized`);
  },
  disable() {
    if (apiEnv === 'test') {
      return;
    }

    throw new TypeError(`BodyScrollLockContext isn't initialized`);
  },
});
